import { AppSettings } from 'core/AppSettings';
import { useEffect } from 'react';
import { getGainsightEventProperties } from './gainsightTrackingGroups';

const DATA_TRACKING_ATTR = 'data-tracking';

/**
 * Sends clicks on data-tracking elements to Gainsight.
 */
export const useGainsightClickTracker = () => {
  useEffect(() => {
    // Only track community sites for now
    if (!AppSettings.isCommunity && !AppSettings.isDevelopment) return;

    const aptrinsic = window.aptrinsic;
    if (typeof aptrinsic !== 'function') return;

    const handleClick = (e: MouseEvent) => {
      const target = e.target;
      if (!(target instanceof HTMLElement)) return;
      const element = target.closest?.(`[${DATA_TRACKING_ATTR}]`);
      const trackingValue = element?.getAttribute?.(DATA_TRACKING_ATTR);
      if (!trackingValue) return;

      const properties = getGainsightEventProperties(trackingValue);
      aptrinsic('track', trackingValue, properties);
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, []);
};
